<div class="password-change-container">
  <h2 mat-dialog-title>{{ 'auth.change password.title' | translate }}</h2>
  <form [formGroup]="passwordChangeForm">
    <mat-dialog-content>
      <div fxLayout="column" fxLayoutGap="1.0rem">
        <mat-form-field>
          <mat-label>{{ 'auth.change password.password current' | translate }}</mat-label>
          <input matInput [type]="hidePasswordCurrent ? 'password' : 'text'" placeholder="{{ 'auth.change password.password current' | translate }}" formControlName="password_current">
          <mat-icon matSuffix (click)="hidePasswordCurrent = !hidePasswordCurrent">
            {{ hidePasswordCurrent ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-hint>{{ 'app.forms.is required' | translate: {item: ('auth.change password.password current' | translate)} }}</mat-hint>
          <mat-error *ngIf="passwordChangeForm.controls.password_current.errors?.required && passwordChangeForm.controls.password_current.touched">
            <span>{{ 'app.forms.is required' | translate: {item: ('auth.change password.password current' | translate)} }}</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'auth.change password.password replace' | translate }}</mat-label>
          <input matInput [type]="hidePasswordReplace ? 'password' : 'text'" placeholder="{{ 'auth.change password.password replace' | translate }}" formControlName="password_replace">
          <mat-icon matSuffix (click)="hidePasswordReplace = !hidePasswordReplace">
            {{ hidePasswordReplace ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-hint>{{ 'app.forms.is required' | translate: {item: ('auth.change password.password replace' | translate)} }}</mat-hint>
          <mat-error *ngIf="passwordChangeForm.controls.password_replace.errors?.required && passwordChangeForm.controls.password_replace.touched">
            <span>{{ 'app.forms.is required' | translate: {item: ('auth.change password.password replace' | translate)} }}</span>
          </mat-error>
        </mat-form-field>
        <div class="password-hints" fxLayout="column">
          <mat-hint class="password-hints-title">
            <span><strong>{{ 'users.register.password hints title' | translate }}</strong></span>
          </mat-hint>
          <mat-hint>
            <mat-icon class="material-icons-outlined check-icon" *ngIf="!passwordChangeForm.controls.password_replace.errors?.formatLength && passwordChangeForm.controls.password_replace.value">done</mat-icon>
            <mat-icon class="material-icons pending-icon" *ngIf="passwordChangeForm.controls.password_replace.errors?.formatLength || !passwordChangeForm.controls.password_replace.value">close</mat-icon>
            <span>{{ 'users.register.password length' | translate }}</span>
          </mat-hint>
          <mat-hint>
            <mat-icon class="material-icons-outlined check-icon" *ngIf="!passwordChangeForm.controls.password_replace.errors?.formatUppercase && passwordChangeForm.controls.password_replace.value">done</mat-icon>
            <mat-icon class="material-icons pending-icon" *ngIf="passwordChangeForm.controls.password_replace.errors?.formatUppercase || !passwordChangeForm.controls.password_replace.value">close</mat-icon>
            <span>{{ 'users.register.password uppercase' | translate }}</span>
          </mat-hint>
          <mat-hint>
            <mat-icon class="material-icons-outlined check-icon" *ngIf="!passwordChangeForm.controls.password_replace.errors?.formatLowercase && passwordChangeForm.controls.password_replace.value">done</mat-icon>
            <mat-icon class="material-icons pending-icon" *ngIf="passwordChangeForm.controls.password_replace.errors?.formatLowercase || !passwordChangeForm.controls.password_replace.value">close</mat-icon>
            <span>{{ 'users.register.password lowercase' | translate }}</span>
          </mat-hint>
          <mat-hint>
            <mat-icon class="material-icons-outlined check-icon" *ngIf="!passwordChangeForm.controls.password_replace.errors?.formatNumber && passwordChangeForm.controls.password_replace.value">done</mat-icon>
            <mat-icon class="material-icons pending-icon" *ngIf="passwordChangeForm.controls.password_replace.errors?.formatNumber || !passwordChangeForm.controls.password_replace.value">close</mat-icon>
            <span>{{ 'users.register.password number' | translate }}</span>
          </mat-hint>
          <mat-hint>
            <mat-icon class="material-icons-outlined check-icon" *ngIf="!passwordChangeForm.controls.password_replace.errors?.formatSpecialCharacter && passwordChangeForm.controls.password_replace.value">done</mat-icon>
            <mat-icon class="material-icons pending-icon" *ngIf="passwordChangeForm.controls.password_replace.errors?.formatSpecialCharacter || !passwordChangeForm.controls.password_replace.value">close</mat-icon>
            <span>{{ 'users.register.password special character' | translate }}</span>
          </mat-hint>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button fxFill mat-raised-button color="primary" (click)="changePassword()" [disabled]="passwordChangeForm.invalid">
        <span>{{ 'app.actions.accept' | translate }}</span>
      </button>
    </mat-dialog-actions>
    <br>
  </form>
</div>
